module.exports = __webpack_public_path__ + "static/SharpSansNo1-Book-dffb495ad039063fda02ae911cd3d00f.ttf";